import { AssetView } from './types/assetTypes';

export function createDefaultAsset(createdBy: string = 'Unknown User'): AssetView {
  const currentDateTime = new Date().toISOString();

  return {
    id: '',

    // Identification
    name: '',
    assetTag: '',
    description: '',
    serialNumber: '',
    manufacturer: '',
    model: '',
    category: '',

    // Location
    center: '',
    building: '',
    floor: '',
    room: '',

    // Status
    status: 'ACTV',

    // Dates
    installDate: undefined,
    warrantyExpiration: undefined,
    expectedLifespan: '',

    // Notes
    notes: '',

    // Audit
    createdBy: createdBy,
    createdDate: currentDateTime,
    lastModifiedDate: currentDateTime,
    lastModifiedBy: createdBy,

    // Computed
    isActive: true,
    isWarrantyExpired: false,
  };
}
